{
  "de": {
    "meta": {
      "description": "FleetYards.net, Deine Datenbank für alle Information rund um die Schiffe & Stationen von “Star Citizen“."
    },
    "model": {
      "focus": "Fokus",
      "classification": "Klassifizierung",
      "size": "Größe",
      "beam": "Breite",
      "cargo": "Fracht",
      "cargoWithModules": "mit Modulen",
      "personalInventory": "Schiffsinventar",
      "beds": {
        "one": "%{count} Bett",
        "other": "%{count} Betten"
      },
      "crew": "Besatzung",
      "speed": "Geschwindigkeit",
      "scmSpeed": "SCM-Geschwindigkeit",
      "scmSpeedBoosted": "SCM-Geschwindigkeit verstärkt",
      "reverseSpeedBoosted": "Rückwärts-Geschwindigkeit verstärkt",
      "maxSpeed": "Max-Geschwindigkeit",
      "scm": "SCM",
      "max": "Max",
      "groundMaxSpeed": "Max-Geschwindigkeit",
      "groundReverseSpeed": "Rückwärts-Geschwindigkeit",
      "pitch": "Nick (Pitch)",
      "pitchBoosted": "Nick verstärkt",
      "yaw": "Gier (Yaw)",
      "yawBoosted": "Gier verstärkt",
      "roll": "Roll",
      "rollBoosted": "Roll verstärkt",
      "price": "Preis",
      "groundAcceleration": "Beschleunigung",
      "compare": {
        "groundMaxSpeed": "Max-Geschwindigkeit am Boden",
        "groundReverseSpeed": "Rückwärts-Geschwindigkeit am Boden",
        "groundAcceleration": "Beschleunigung am Boden",
        "groundDeceleration": "Abbremsung am Boden"
      },
      "quantumFuelTankSize": "Quantum Treibstoff",
      "hydrogenFuelTankSize": "Treibstoff",
      "pledgePrice": "Pledge-Preis",
      "height": "Höhe",
      "length": "Länge",
      "mass": "Masse",
      "manufacturer": "Hersteller",
      "hardpoints": "Aufhängungen",
      "weapons": "Waffen",
      "equipment": "Ausrüstung",
      "variants": "Varianten",
      "productionStatus": "Produktionsstatus",
      "propulsion": "Antrieb",
      "modular": "Modular",
      "soldAt": "Verkauft bei?",
      "rentalAt": "Vermietung bei?",
      "poweredByUex": "Bereitgestellt von UEX",
      "lastUpdatedAt": "Zuletzt aktualisiert am?"
    },
    "component": {
      "manufacturer": "Hersteller",
      "size": "Größe"
    },
    "availability": {
      "soldAt": "Verkauft bei",
      "boughtAt": "Gekauft von"
    },
    "resources": {
      "models": "Schiffe",
      "hardpoints": "Aufhängungen",
      "images": "Bilder"
    },
    "pagination": {
      "previous": "Vorherige Seite",
      "next": "Nächste Seite",
      "gap": "&hellip;"
    }
  }
}
